<!-- <p>queue-alerts-list works!</p> -->
<app-resource-form-card
  [title]="service.title()"
  [resource]="service.resource"
  [detailed]="detailed()"
  [list]="true"
  [createButton]="access()?.queue_alert?.actions?.create"
>
  <p-table
    [value]="value()"
    [paginator]="true"
    dataKey="_id"
    [expandedRowKeys]="expandedRows"
    [rows]="5"
    [rowsPerPageOptions]="[5, 10, 20]"
    [scrollable]="true"
    scrollHeight="flex"
  >
    <ng-template pTemplate="header" let-columns>
      <tr>
        <th style="width: 5rem"></th>
        <th pSortableColumn="trigger_people_quantity" class="min-w-32">
          Personas en espera para activar
          <p-sortIcon field="trigger_people_quantity" />
        </th>
        @if (detailed()) {
          <th pSortableColumn="formattedTargetPeopleLength" class="min-w-32">
            Personas a notificar
            <p-sortIcon field="formattedTargetPeopleLength" />
          </th>
          <th pSortableColumn="cooldown" class="min-w-32">
            Tiempo de espera <p-sortIcon field="cooldown" />
          </th>
          <th pSortableColumn="template" class="min-w-32">
            Plantilla de notificación <p-sortIcon field="template" />
          </th>
          @if (access()?.servicio?.actions?.read) {
            <th pSortableColumn="service.name">
              Servicio <p-sortIcon field="service.name" />
            </th>
          }
          @if (access()?.branch?.actions?.read) {
            <th pSortableColumn="branch.name">
              Sucursal <p-sortIcon field="branch.name" />
            </th>
          }
          @if (access()?.contract?.actions?.read) {
            <th pSortableColumn="contract.name">
              Contrato <p-sortIcon field="contract.name" />
            </th>
          }
        }
        <th class="action">Acciones</th>
      </tr>
      @if (detailed()) {
        <tr>
          <th>
            <!-- <p-columnFilter
              type="text"
              field="trigger_people_quantity"
              placeholder="Personas en espera para activar"
              ariaLabel="Filter Trigger People Quantity"
            /> -->
          </th>
          <th>
            <!-- <p-columnFilter
              type="text"
              field="formattedTargetPeopleLength"
              placeholder="Personas a notificar"
              ariaLabel="Filter Target People Length"
            /> -->
          </th>
          <th>
            <!-- <p-columnFilter
              type="text"
              field="cooldown"
              placeholder="Tiempo de espera"
              ariaLabel="Filter Cooldown"
            /> -->
          </th>
          <th>
            <p-columnFilter
              type="text"
              field="templete"
              placeholder="Plantilla de notificación"
              ariaLabel="Filter Templete"
            />
          </th>
          @if (access()?.servicio?.actions?.read) {
            <th>
              <p-columnFilter
                type="text"
                field="service.name"
                placeholder="Servicio"
                ariaLabel="Filter Service Name"
              />
            </th>
          }
          @if (access()?.branch?.actions?.read) {
            <th>
              <p-columnFilter
                type="text"
                field="branch.name"
                placeholder="Sucursal"
                ariaLabel="Filter Branch Name"
              />
            </th>
          }
          @if (access()?.contract?.actions?.read) {
            <th>
              <p-columnFilter
                type="text"
                field="contract.name"
                placeholder="Contrato"
                ariaLabel="Filter Contract Name"
              />
            </th>
          }
        </tr>
      }
    </ng-template>
    <ng-template pTemplate="body" let-value let-expanded="expanded">
      <tr>
        <td>
          <p-button
            type="button"
            pRipple
            [pRowToggler]="value"
            [text]="true"
            [rounded]="true"
            [plain]="true"
            [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"
          />
        </td>
        <td>{{ value.formattedTriggerPeopleQuantity }}</td>
        @if (detailed()) {
          <td>
            {{ value.formattedTargetPeopleLength }}
            <!-- <app-target-people-list
              [value]="value.targetPeople"
            ></app-target-people-list> -->
          </td>
          <td>{{ value.formattedCooldown }}</td>
          <td>{{ value.formattedTemplete }}</td>
          @if (access()?.servicio?.actions?.read) {
            <td>{{ value.formattedServiceName }}</td>
          }
          @if (access()?.branch?.actions?.read) {
            <td>{{ value.formattedBranchName }}</td>
          }
          @if (access()?.contract?.actions?.read) {
            <td>{{ value.formattedContractName }}</td>
          }
        }
        <td>
          <div>
            <app-resource-button-group
              [resource]="service.resource"
              [resourceId]="value._id"
              [detailsButton]="true"
              [editButton]="access()?.queue_alert?.actions?.update"
              [deleteButton]="access()?.queue_alert?.actions?.delete"
              [iconOnly]="true"
            >
            </app-resource-button-group>
          </div>
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="rowexpansion" let-value>
      <tr>
        <td colspan="100%">
          <div>
            <app-target-people-list
              [value]="value.target_people"
              [resource]="service.resource"
              [(loading)]="loading"
              (saveChanges)="updateTargetPeople($event, value._id)"
            ></app-target-people-list>
          </div>
        </td>
      </tr>
    </ng-template>
  </p-table>
</app-resource-form-card>
